import { useMemo, useState } from "react";
import { detectChapters, proposeMomentsFromChapters } from "../domain/markdownImport";
import { useStore } from "../store";

const KNOWN = [
  { path: "sources_markdown/01_tome_1_aube_alteree.md", label: "Tome 1 — L’Aube Altérée" },
  { path: "sources_markdown/04_tome_2_les_fragments.md", label: "Tome 2 — Les Fragments" },
  { path: "sources_markdown/06_tome_3_chapitre_01_anomalies_acceptees.md", label: "Tome 3 ch. 1" },
  { path: "sources_markdown/07_tome_3_chapitre_02_resonances.md", label: "Tome 3 ch. 2" },
  { path: "sources_markdown/08_tome_3_chapitre_03_echo_des_falaises.md", label: "Tome 3 ch. 3" },
  { path: "sources_markdown/09_tome_3_chapitre_04_dissonances.md", label: "Tome 3 ch. 4" },
  { path: "sources_markdown/02_fiches_personnages.md", label: "Fiches personnages (secondaire)" },
  { path: "sources_markdown/03_chronologie_existante.md", label: "Chronologie existante (secondaire)" },
  { path: "sources_markdown/05_resumes_rapides.md", label: "Résumés rapides (secondaire)" },
];

export function SourcesPage() {
  const { bible } = useStore();
  const [text, setText] = useState("");
  const [path, setPath] = useState("sources_markdown/chapitre.md");
  const proposals = useMemo(() => {
    if (!bible || !text.trim()) return [];
    const detected = detectChapters(text, path);
    return proposeMomentsFromChapters(
      detected,
      bible.moments.map((m) => ({ id: m.id, bookId: m.bookId, chapterNumber: m.chapterNumber })),
    );
  }, [bible, path, text]);

  return (
    <div className="grid">
      <h1>Sources et importations</h1>
      <section className="card">
        <h2>Manuscrits du kit</h2>
        <p className="tiny">Les fichiers Markdown restent la source littéraire. La Bible ne stocke que les faits structurés et leurs références. Aucune extraction massive automatique.</p>
        <ul>
          {KNOWN.map((k) => (
            <li key={k.path}><code>{k.path}</code> — {k.label}</li>
          ))}
        </ul>
      </section>
      <section className="card">
        <h2>Détection de chapitres (file de révision)</h2>
        <p className="tiny">Collez un chapitre Markdown. Les propositions restent en <strong>verify</strong> jusqu’à validation humaine. Rien ne passe en canon ici.</p>
        <label className="field">
          <span>Chemin source</span>
          <input value={path} onChange={(e) => setPath(e.target.value)} />
        </label>
        <textarea rows={10} value={text} onChange={(e) => setText(e.target.value)} placeholder="# Chapitre 21 – Titre" />
        <div className="list" style={{ marginTop: 12 }}>
          {proposals.map((p) => (
            <article key={p.fingerprint} className="item">
              <strong>Ch. {p.chapterNumber} — {p.title}</strong>
              <div className="tiny">{p.bookId ?? "tome inconnu"} · {p.existingMomentId ?? "nouveau"} · {p.status}</div>
              <div className="tiny">{p.note}</div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
